/**
 * Minimaler GA4-Tracking-Helper.
 *
 * Sendet nur, wenn das gtag-Script bereits geladen ist (= User hat Cookie-Consent
 * für Statistik gegeben). Vor Consent wird stillschweigend nichts gesendet.
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return; // not loaded yet → user hasn't consented
  if (/^\/(dashboard|portal|kanzlei|mandantenerfassung|meine-|team|admin|dokumente|profil|downloads|signatur|akontozahlung|ratenzahlung|rueckruf|notfallkontakt)/.test(window.location.pathname)) return;
  try {
    window.gtag('event', eventName, params);
  } catch (e) {
    /* ignore tracking errors – tracking must never break the app */
  }
};
